module.exports = __webpack_public_path__ + "media/shapes-preview@lg-0e1600443d91d54dddfbde988b7fbe05.gif";